import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import useModal from '@hooks/ui/useModal';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { AxiosError } from 'axios';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    id: string;
    balance: number;
}

function useDeletePrepaidCard({ id, balance }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { openModal, closeModal } = useModal();
    const toast = useToast();
    const deletePrepaidCard = () => {
        closeModal();
        UserPrepaidCardApi.deletePrepaidCard(id)
            .then(() => {
                toast.info(t('manage.delete.success'));
            }).catch((e: AxiosError<ErrorResponse>) => {
                toast.error(e.response?.data.message || t('manage.delete.error'));
            });
    };
    const handleDelete = (e: MouseEvent<HTMLOrSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (balance !== 0) {
            toast.error(t('manage.delete.balanceError'));
            return;
        }
        openModal(<Column align='center' spacing={36} fullWidth>
            <Text align='center' size='xl'>
                {t('manage.delete.confirm')}
            </Text>
            <Column fullWidth spacing={10}>
                <Button variant='secondary'
                    fullWidth
                    onClick={closeModal}>
                    {t('manage.delete.cancel')}
                </Button>
                <Button fullWidth onClick={deletePrepaidCard}>
                    {t('manage.delete.deleteButton')}
                </Button>
            </Column>
        </Column>);
    };

    return { handleDelete };
}

export default useDeletePrepaidCard;
